import { useEffect, useState } from "react";
import { Modal, Table } from "react-bootstrap";
import Loader, { LoaderType } from "../../component/common-component/Loader";
import Nodata from "../../component/common-component/Nodata";

import { useDispatch } from "react-redux";
import { FetchInvoiseById } from "../../services/ReduxTookit/Slice/InvoiceRedux";

const InvoiceDetailsModal = ({
  selectedMonth,
  selectedYear,
  showModal,
  closeModel,
  payload,
}) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [invoiceDetailList, setInvoiceDetailList] = useState(null);

  const getInvoiceDataById = async (id) => {
    setLoading(true);
    dispatch(FetchInvoiseById(id))
      .then((response) => {
        if (response?.payload?.isValidate) {
          setInvoiceDetailList(response?.payload?.data?.data?.dataList1);
        }
        if (!response?.payload?.isValidate) {
          setInvoiceDetailList([]);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (payload) {
      getInvoiceDataById(payload);
    }
  }, [payload]);

  return (
    <Modal
      show={showModal}
      onHide={closeModel}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          <div className="d-flex gap-2 align-items-center">
            <h6>
              Earning Details - {selectedMonth && selectedMonth}{" "}
              {selectedYear && selectedYear}
            </h6>
          </div>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="table-wrapper-main">
          <Table responsive>
            <thead>
              <tr>
                <th>Machine Name</th>
                <th>Type</th>
                <th className="text-end">Amount</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <Loader type={LoaderType.TableRow} count={3} nooftd={3} />
              ) : (
                <>
                  {invoiceDetailList ? (
                    <>
                      {invoiceDetailList?.map((item) => {
                        return (
                          <tr key={`orderDetail-${item?.orderid}`}>
                            <td>{item?.machinename}</td>
                            <td>{item?.associationtype}</td>
                            <td className="text-end">{`$${item?.amount}`}</td>
                          </tr>
                        );
                      })}
                    </>
                  ) : (
                    <tr>
                      <td colSpan={4}>
                        <Nodata />
                      </td>
                    </tr>
                  )}
                </>
              )}
            </tbody>
          </Table>
        </div>
      </Modal.Body>

      {/* <Modal.Footer>
        <button className="grey-btn w-auto" onClick={closeModal}>
          Cancel
        </button>
         
      </Modal.Footer> */}
    </Modal>
  );
};

export default InvoiceDetailsModal;
